import { useState } from 'react';
import styled from 'styled-components';

import { U21Button, U21MenuLayout } from 'app/shared/u21-ui/components';
import {
  IconBookmark,
  IconChevronDown,
  IconChevronUp,
} from '@u21/tabler-icons';

import { FilterContext, SavedFilter } from 'app/modules/filters/models';
import { SavedFilterPanel } from 'app/modules/filters/components/SavedFilterPanel';

interface Props {
  appliedSavedFilter?: SavedFilter;
  appliedSavedFilterIds: Set<number>;
  filterContext: FilterContext;
  onApply: (savedFilter: SavedFilter) => void;
  onAppliedSavedFilterChange: (savedFilter: SavedFilter | undefined) => void;
  savedFilters: SavedFilter[];
  staleSavedFilterIds: Set<number>;
}

export const SavedFiltersMenuButton = ({
  appliedSavedFilter,
  appliedSavedFilterIds,
  filterContext,
  onApply,
  onAppliedSavedFilterChange,
  savedFilters,
  staleSavedFilterIds,
}: Props) => {
  const [open, setOpen] = useState(false);

  return (
    <U21MenuLayout
      onClose={() => setOpen(false)}
      open={open}
      trigger={
        <U21Button
          color="primary"
          endIcon={open ? <IconChevronUp /> : <IconChevronDown />}
          onClick={() => setOpen(true)}
          size="small"
          startIcon={<IconBookmark />}
        >
          Saved Filters
        </U21Button>
      }
    >
      <MenuContent>
        <SavedFilterPanel
          appliedSavedFilterIds={appliedSavedFilterIds}
          filterContext={filterContext}
          onApply={(savedFilter) => {
            onApply(savedFilter);
            setOpen(false);
          }}
          onDeleted={(savedFilter) => {
            if (savedFilter.id === appliedSavedFilter?.id) {
              onAppliedSavedFilterChange(undefined);
            }
          }}
          savedFilters={savedFilters}
          staleSavedFilterIds={staleSavedFilterIds}
        />
      </MenuContent>
    </U21MenuLayout>
  );
};

const MenuContent = styled.div`
  min-width: 320px;
  max-width: 600px;
`;
